export default async function getObjetivo() {
  const endpoint = localStorage.getItem("endpoint");
  const url = endpoint + "adm_clasificacionitemplan/items";

  try {
    const config = { method: "GET", headers: {} };
    const response = await fetch(url, config);
    const json = await response.json();

    return json;
  } catch (error) {
    console.log("Error" + error);
  }
}
